// NB: Start to Finnish has also a non-AI Edu course
export const aiEduCourses = {
  "h539yz66tgbkjx7e": "english101",
  "58kz1braltaklhzv": "emath",
  "fvwu30r5jkwb946d": "innovation-management-1",
  "uc4ugwjwvh18khcw": "innovation-management-2",
  "xzqro933sc68kcse": "ai-edu-tutorial",
  "mi2k8lcql74f1tk7": "suomi-a1",
  "4chx6fqcxpm8ywmd": "starttofinnish"
}